export const SET_FEATURE_LIMITS = 'SET_FEATURE_LIMITS'
